module.exports = __webpack_public_path__ + "static/media/barners_particuliers_mobile.133273a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/assets/images/barners_particuliers_mobile.jpg
// module id = 770
// module chunks = 0